<template>
  <transition name="slide-fade" appear>
    <div v-if="show" :class="['toast-container', {'top-right': showFixedTopRight}]">
      <div :class="['toast-element', kind]">
        <slot name="message-content" />
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    kind: {
      type: String,
      required: false,
      default: 'success'
    },
    showFixedTopRight: {
      type: Boolean,
      required: false,
      default: true
    },
    showOnMount: {
      type: Boolean,
      default: true
    }
  },

  emits: ['hidden'],

  data() {
    return {
      show: false
    }
  },

  mounted() {
    if (this.showOnMount) {
      this.showToast()
    }
  },

  methods: {
    removeToast() {
      this.show = false
      this.$emit('hidden')
    },

    showToast() {
      this.show = true
      setTimeout(() => {
        this.removeToast()
      }, 4000)
    }
  }
}

</script>

<style lang="scss" scoped>
  @use "~common_styles/breakpoints" as breakpoints;
  @use "~friendship_styles/colors" as colors;
  @use "~friendship_styles/zindex" as zindex;

  .toast-container {
    // Positioning

    // By default, display at the element parent's location without taking space, this is overriden
    // if the toast is meant to be displayed at the top right of the screen.
    position: absolute;

    &.top-right {
      position: fixed;
      z-index: zindex.$toast-z-index;
      top: 10%;
      right: 7%;
    }

    // toast element styling
    // Not using the class name `toast` to avoid using unrelated bootstrap class.
    .toast-element {
      top: 35px;
      width: auto;
      clear: both;
      margin-top: 10px;
      position: relative;
      max-width: 100%;
      height: auto;
      word-break: normal;
      display: flex;
      align-items: center;
      justify-content: space-between;
      box-sizing: inherit;
      padding: 15px;
      color: colors.$black;
      border-radius: 5px;
    }

    // This class is dynamically applied based on a prop
    /* eslint-disable-next-line vue-scoped-css/no-unused-selector */
    .success {
      background-color: colors.$alert-success-bg;
      border: 1px solid colors.$alert-success-fg;
    }

    // This class is dynamically applied based on a prop
    /* eslint-disable-next-line vue-scoped-css/no-unused-selector */
    .error {
      background-color: colors.$alert-danger-bg;
      border: 1px solid colors.$alert-danger-fg;
    }
  }

  @include breakpoints.screen-mobile-only {
    .toast-container {
      max-width: 86%;
      width: 100%;

      &.top-right {
        top: 0;
        float: none;
      }
    }
  }

  .slide-fade-enter-active {
    transition: all .3s ease;
  }
  .slide-fade-leave-active {
    transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .slide-fade-enter-from {
    transform: translateY(-30px);
    opacity: 0;
  }
  .slide-fade-leave-to {
    opacity: 0;
  }
</style>
